import { useDaysToFirstPaymentField } from '@makemydeal/dr-dash-components';
import { NumericInput } from '@makemydeal/dr-shared-components/numeric-input';

import { useScenarioCellId } from '../../../hooks/useScenarioCellId';
import { ScenarioRow } from '../../ScenarioRow';

export const DaysToFirstPaymentRow = () => {
    const { label, inputProps } = useDaysToFirstPaymentField();
    const inputId = useScenarioCellId('daysToFirstPayment');

    return (
        <ScenarioRow rowKey="daysToFirstPayment" label={label} inputId={inputId}>
            <NumericInput {...inputProps} id={inputId} />
        </ScenarioRow>
    );
};
